"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YardSignOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var YardSignOutlineSVG = function YardSignOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,6H8V2.93a1,1,0,0,0-2,0V6H2.89a1,1,0,0,0,0,2H6V29.06A1,1,0,0,0,7,30a1,1,0,0,0,1-.93V8h4v2a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2V8h3a1,1,0,0,0,0-2ZM26,21H12V12H26ZM24,10H14V8H24Z"
  }));
};
exports.YardSignOutlineSVG = YardSignOutlineSVG;
YardSignOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(YardSignOutlineSVG);
exports.default = _default;